import React from 'react';
import { getSathiBulkActionNotificationDisplay, getSathiBulkActionNotificationListId } from '@/utils/sathi-bulk-action-notification-utils';
import { timeAgo } from '@/utils/ts/stringUtils';
import { useNavigate } from 'react-router-dom';



import RightArrow from '@/components/Icons/icons/RightArrow';



import AvatarComponent from '../../AvatarComponent/AvatarComponent';
import ButtonComponent from '../../ButtonComponent/ButtonComponent';
import IconContainer from '../../FtuxComponent/IconContainer';


export default function SathiBulkActionCompletedNotification({
  notification,
  setShowNotificationDropdown,
}) {
  const navigate = useNavigate();
  const { title, bodyLines, icon } = getSathiBulkActionNotificationDisplay(notification);
  const influencers = notification?.content?.influencers ?? [];
  const listId = getSathiBulkActionNotificationListId(notification);

  const handleViewInfluencers = () => {
    if (!listId) return;
    navigate(`/dashboard/list/detail/${listId}`);
    setShowNotificationDropdown?.(false);
  };

  return (
    <div className={`single-notification sathi-bulk-action-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <IconContainer icon={icon} bgColor="var(--background-default)" className="small" />
      </div>
      <div className="text-div">
        <h3 className="title">{title}</h3>
        {bodyLines.map((line, index) => (
          <p key={`${index}-${line}`} className="description sathi-bulk-action-notification__body-line">
            {line}
          </p>
        ))}
        {listId && (
          <div className="sathi-bulk-action-notification__action-row">
            <ButtonComponent
              variant="text-highlight"
              className="p-0"
              textStyle={{ fontSize: 14 }}
              onClick={handleViewInfluencers}
              rightIcon={<RightArrow color="var(--text-highlight)" />}>
              View Influencers
            </ButtonComponent>
          </div>
        )}
        <p className="timestamp">{timeAgo(notification?.createdAt)}</p>
      </div>
    </div>
  );
}